import React, { Component } from 'react';
// import { getAccInfo, setUnbind, rechargeBalance, } from './service'
// import { getCampusPay } from '../cardBinding/service'
import { get, post, url_kh } from '../../utils/http'
import { Toast, Form, Input, Button, Modal, Dialog, Space, SpinLoading } from 'antd-mobile'
import MD5 from '../../common/md5'
import { debounce } from '../../utils/util'
import './index.scss';
import wx from 'weixin-js-sdk';

var browser = {
  versions: function () {
      var u = navigator.userAgent;
      return {
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
      };
  }(),
}

class RechargeCardKaiHe extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            projectId: null,
            userInformation: {},
            rechargeStatus: false,
            rechargeMoney: null,
            payWay: null,
            telPhone: null,
            loginCode: null,
            isLoading: true,
            phoneSystem: null,
        }
        this.onSubmit = debounce(this.onSubmit, 1000)

    }
    componentDidMount() {
        document.title = "一卡通充值"
        let search = window.location.search.slice(1)
        let params = search.split('&')
        var theRequest = new Object()
        for (let i = 0; i < params.length; i++) {
            theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
        }
        const script = document.createElement('script');
        script.src = 'https://appx/web-view.min.js';
        document.head.appendChild(script);
        this.setState({
            projectId: theRequest.projectId,
            rechargeMoney: theRequest.rechargeMoney,
            payWay: theRequest.payWay,
            telPhone: theRequest.telPhone,
            loginCode: theRequest.loginCode,
            accountId: theRequest.accountId,
            phoneSystem: theRequest.phoneSystem,
        }, () => {
            this.getAccountInfo()
        })
    }

    // 解绑成功返回
    onBackUnbind = () => {
        var userAgent = navigator.userAgent;
        const OpenHarmony = /(OpenHarmony).*?/.test(userAgent);
        const ua = userAgent.toLowerCase();
        const isWeChat = /micromessenger/.test(ua);
        if (isWeChat) {
            // 在微信中，尝试使用小程序接口
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    wx.miniProgram.navigateBack({
                        delta: 1
                    })
                    return;
                }
            })
        }
        if (browser.versions.android || OpenHarmony) {
            window.android.onCampusPayExit();
            return;
        }
        if (browser.versions.ios) {
            window.webkit.messageHandlers.onCampusPayExit.postMessage('');
            return;
        }
    }
    // 充值成功返回
    onBackRecharge = () => {
        var userAgent = navigator.userAgent;
        const OpenHarmony = /(OpenHarmony).*?/.test(userAgent);
        const ua = userAgent.toLowerCase();
        const isWeChat = /micromessenger/.test(ua);
        if (isWeChat) {
            // 在微信中，尝试使用小程序接口
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    wx.miniProgram.navigateBack({
                        delta: 1
                    })
                    return;
                }
            })
        }
        if (browser.versions.android || OpenHarmony) {
            window.android.onCampusPayGoBack();
            return;
        }
        if (browser.versions.ios) {
            window.webkit.messageHandlers.onCampusPayExit.postMessage('');
            return;
        }
    }

    getAccountInfo = () => {
        let { projectId, rechargeMoney, organizationName, telPhone, loginCode, payWay, accountId, phoneSystem } = this.state
        let params = {
            projectId: projectId,
            loginCode: loginCode,
            telPhone: telPhone,
        }
        if (phoneSystem) {
            params.phoneSystem = phoneSystem;
        }
        get(`${url_kh}/campus/accountInfo`, params)
            .then(res => {
                if (res.errorCode == 0) {
                    this.setState({
                        userInformation: res.data,
                        isLoading: false
                    })
                } else if (res.errorCode == 65) {
                    Toast.show({
                        content: res.message,
                        position: 'bottom',
                    })
                    setTimeout(() => {
                        this.props.history.push('/bindingCardKaiHe?rechargeMoney='
                            + rechargeMoney + '&projectId=' + projectId + '&telPhone=' + telPhone
                            + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId + '&phoneSystem=' + phoneSystem)
                    }, 1000);
                } else {
                    Toast.show({
                        content: res.message,
                        position: 'bottom',
                    })
                    this.setState({
                        isLoading: false
                    })
                }
            })
    }
    onChangeCardUnbind = () => {
        let { projectId, rechargeMoney, organizationName, telPhone, loginCode, payWay, accountId, phoneSystem } = this.state
        // let params = {
        //     projectId,
        //     loginCode,
        //     telPhone
        // }
        // if (phoneSystem) {
        //     params.phoneSystem = phoneSystem;
        // }
        const formData = new URLSearchParams();
        formData.append('projectId', projectId);
        formData.append('loginCode', loginCode);
        formData.append('telPhone', telPhone);
        if (phoneSystem) {
            formData.append('phoneSystem', phoneSystem);
        }
        fetch(`${url_kh}/campus/unbind`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData.toString()
        })
            .then(response => response.json())
            .then(res => {
            if (res.errorCode == 0) {
                Toast.show({
                    content: '解绑成功！',
                    position: 'bottom',
                })
                setTimeout(() => {
                    this.onBackUnbind()
                }, 1000);
            } else {
                Toast.show({
                    content: res.message,
                    position: 'bottom',
                })
            }
        })
    }
    /**
      * 充值
      */
    onSubmit = () => {
        this.setState({
            isLoading: true
        })
        let { organizationName, telPhone, payWay, rechargeMoney, accountId, loginCode, projectId, phoneSystem } = this.state
        let signature = 'loginCode' + loginCode + 'payWay' + payWay +
            'rechargeMoney' + rechargeMoney + 'telPhone' + telPhone + 'sign-kailu='
        console.log('signature', signature)
        signature = MD5.md5(signature).toLowerCase()
        const formData = new URLSearchParams();
        formData.append('rechargeMoney', rechargeMoney);
        formData.append('projectId', projectId);
        formData.append('loginCode', loginCode);
        formData.append('accountId', accountId);
        formData.append('telPhone', telPhone);
        formData.append('payWay', payWay);
        formData.append('signature', signature);
        if (phoneSystem) {
            formData.append('phoneSystem', phoneSystem);
        }
        fetch(`${url_kh}/campus/recharge/balance`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData.toString()
        })
            .then(response => response.json())
            .then(res => {
            if (res.errorCode == 0) {
                this.setState({
                    isLoading: false
                })
                Toast.show({
                    content: '充值成功！',
                    position: 'bottom',
                })
                setTimeout(() => {
                    this.onBackRecharge()
                }, 1000);
            } else if (res.errorCode == 145) {
                Toast.show({
                    content: res.message,
                    position: 'bottom',
                })
                this.setState({
                    isLoading: false
                })
                setTimeout(() => {
                    this.props.history.push('/bindingCardKaiHe?rechargeMoney='
                        + rechargeMoney + '&projectId=' + projectId + '&telPhone=' + telPhone
                        + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId + '&phoneSystem=' + phoneSystem)
                }, 1000);
            } else {
                this.setState({
                    isLoading: false
                })
                Toast.show({
                    content: res.message,
                    position: 'bottom',
                })
            }
        })
    }
    render() {
        const { userInformation, organizationName, rechargeMoney, } = this.state
        //解绑
        const unbind = () => {
            Dialog.confirm({
                title: "确认解绑一卡通",
                content: '确定要解绑当前一卡通账户？',
                onConfirm: async () => {
                    await this.onChangeCardUnbind()
                    return true
                },
            })
        }
        return (
            <>
                {!this.state.isLoading ? <div className="recharge-card-page">
                    <Form layout='horizontal'
                        key={userInformation.balance}
                        onFinish={this.onSubmit}
                        footer={
                            <Button block color='primary' type='submit' size='large'>
                                确认充值
                            </Button>
                        }
                    >
                        <div className="user-Unbinding">
                            <div className="user-Unbinding-label">一卡通账户:</div>
                            <Button color='primary' onClick={() => { unbind() }} fill='none'>解绑</Button>
                        </div>
                        <Form.Item label='账户信息:' name='campusUser' className="user-information" >
                            <Input readOnly style={{ '--text-align': 'right' }} defaultValue={userInformation.campusUser || ''} placeholder='' clearable />
                        </Form.Item>
                        <Form.Item label='账户状态:' name='status' className="user-status" >
                            <Input readOnly style={{ '--text-align': 'right' }} defaultValue={userInformation.status || '--'} placeholder='' clearable />
                        </Form.Item>
                        <Form.Item label='账户金额:' name='balance' className="user-money" >
                            <Input readOnly style={{ '--text-align': 'right' }} defaultValue={userInformation.balance ? (userInformation.balance / 100).toFixed(2) + '元' : '--'} placeholder='请输入' clearable />
                        </Form.Item>
                    </Form>
                    <div className="card-recharge-btn">
                        <div className="user-Unbinding-label">充值金额:</div>
                        <Input key={rechargeMoney} readOnly style={{ '--text-align': 'right' }} placeholder='' defaultValue={(rechargeMoney || '0') + '元'} clearable />
                    </div>
                </div>
                    :
                    <div className="recharge-page-loading">
                        <Space direction='horizontal' wrap block style={{ '--gap': '16px' }}>
                            <SpinLoading color='primary' />
                        </Space>
                    </div>

                }
            </>
        );
    }

}

export default RechargeCardKaiHe;